import Checkbox from "@mui/material/Checkbox";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from "@mui/material";

const SfsTriggerFigureCheckbox = ({ id, expenditureType, triggerSum, checked, setChecked}) => {
    const checkboxLabel = <Typography textAlign="left">
        The total value you have entered for {" "}
        <b>{expenditureType}</b> is higher than the monthly national average of <b>£{triggerSum}</b>. If this is incorrect, please review and update your figures. If the value is correct, please tick the box to continue.
    </Typography>
    const checkbox = <Checkbox
        checked={checked}
        onChange={(event) => setChecked(event.target.checked)}
        inputProps={{ "aria-label": "controlled" }}
        sx={{
            marginRight: { xs: "8px", sm: 0 },
            marginBottom: { xs: "8px", sm: 0 },
        }}
    />
    return (
        <FormGroup>
            <FormControlLabel 
                control={checkbox} 
                label={checkboxLabel}
                id={id}
                sx={{
                    margin: 2
                }}
                labelPlacement="end" />
        </FormGroup>);
}

export default SfsTriggerFigureCheckbox;